import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";
import axiosInstance from "../axiosConfig";

const PurchaseBillUpload = () => {
  const [records, setRecords] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // const [uploadId, setUploadId] = useState(null);
// Prefix options for PO Number
const PO_PREFIXES = ["POAL-", "POR-", "POA-"];

// Local UI state just for the split control
const [poPrefix, setPoPrefix] = useState("");
const [poSuffix, setPoSuffix] = useState("");

// keep formData.PO_Number in sync when either part changes
useEffect(() => {
  const combined = (poPrefix || "") + (poSuffix || "");
  setFormData(prev => ({ ...prev, PO_Number: combined }));
}, [poPrefix, poSuffix]);

  const [formData, setFormData] = useState({
    BillNumber: "",
    Quantity: "",
    Remarks: "",
    PO_Number: "",
    Loading_Unloading_amount: "",
    Product: "",
    Transporter_Name: "",
    Quantity_in_KG: "",
    UOM: ""
  });


  // Option lists
  const PRODUCT_OPTIONS = [
    "Bardan",
    "Buckles",
    "Carton Big Box",
    "Carton Tape",
    "Coated Textile Fabric (Rexine) (Heavy)",
    "Coated Textile Fabric (Rexine) (Lite)",
    "Color",
    "CRCA Coil",
    "Dozen Bag",
    "Granules (PVC Compound)",
    "Latex",
    "Packing Patti Roll (Lite) & (Heavy)",
    "Panni Tape",
    "Patti Clip",
    "PVC Pouch (Panni)",
    "Screw",
    "Silica Gel",
    "Steel Wire",
    "Top & Bottom Box",
    "Thread",    
  ];

  const TRANSPORTER_OPTIONS = [
    "AURUM TRANS SOLUTIONS PRIVATE LIMITED",
    "AVINASH CARGO PVT.LTD.",
    "DELHI BOMBAY SPEED CARGO CARRIER",
    "SMARTSHIFT LOGISTICS SOLUTIONS PVT LTD (PORTER)",
    "Others",
  ];


  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const fetchRecords = async () => {
    try {
      const response = await axiosInstance.get("/api/upload-purchase");
      setRecords(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const user = JSON.parse(localStorage.getItem("user"));
    const dataToSend = {
      ...formData,
      CreatedBy: user?.Name || "Unknown"
    };

    try {
      await axiosInstance.post("/api/upload-purchase", dataToSend);
      showAlert("Record added successfully!", "success");
      setShowModal(false);
      // setFormData({ BillNumber: "", Quantity: "",  Remarks: "",
      //               PO_Number: "",
      //               Loading_Unloading_amount: "",
      //               Product: "",
      //               Transporter_Name: "", Quantity_in_KG: "" });
      fetchRecords();
    } catch (err) {
      showAlert("Failed to add record", "danger");
    }
  };

  const handleImageUpload = async (e, id) => {
    const file = e.target.files[0];
    if (!file || !id) return;

    const user = JSON.parse(localStorage.getItem("user"));
    const formData = new FormData();
    formData.append("image", file);
    formData.append("UploadedBy", user?.Name || "Uploader");

    try {
      await axiosInstance.patch(`/api/upload-purchase/${id}/upload-image`, formData);
      showAlert("Bill image uploaded!", "success");
      fetchRecords();
    } catch (err) {
      showAlert("Failed to upload image", "danger");
    }
  };

  const API_BASE_URL = axiosInstance.defaults.baseURLPath;

  const handleViewImage = (imagePath) => {
    setSelectedImage(`${API_BASE_URL}/uploads/${imagePath}`);
    setShowImageModal(true);
  };
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
  
    try {
      await axiosInstance.delete(`/api/upload-purchase/${id}`);
      showAlert("Record deleted successfully", "success");
      fetchRecords();
    } catch (err) {
      console.error("Delete failed", err);
      showAlert("Failed to delete record", "danger");
    }
  };
  
  const columns = [
    { name: "Bill Number", selector: (row) => row.BillNumber, sortable: true },
    { name: "Quantity", selector: (row) => row.Quantity, sortable: true },
     // NEW FIELDS 
    { name: "Qty in KG / pcs", selector: (row) => row.Quantity_in_KG || "N/A", sortable: true },
    { name: "PO Number", selector: (row) => row.PO_Number || "N/A", sortable: true },
    { name: "L/U Amount", selector: (row) => row.Loading_Unloading_amount || "N/A", sortable: true },
    { name: "Product", selector: (row) => row.Product || "N/A", sortable: true },
    { name: "Transporter",width:"150px", selector: (row) => (
        <span data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={row.Transporter_Name}>

          {row.Transporter_Name || "N/A"}
          </span>
        
    ), sortable: true },

    {
      name: "Status",
      selector: (row) => (
        <span
          style={{
            padding: "4px 12px",
            borderRadius: "6px",
            fontWeight: "bold",
            display: "inline-block",
            color:
              row.Status === "Received" ? "#155724" : "#856404",
            backgroundColor:
              row.Status === "Received" ? "#d4edda" : "#fff3cd"
          }}
        >
          {row.Status}
        </span>
      ),
      sortable: true
    },
    {
      name: "Remarks",width:"150px",
      selector: (row) => (
        <span data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.Remarks}>

         {row.Remarks || "N/A"}
        </span>
      ),
    //   row.Remark,
      sortable: false,
    },
    {
      name: "Image",
      cell: (row) =>
        row.BillImagePath ? (
          <button
            className="btn btn-sm btn-outline-info"
            onClick={() => handleViewImage(row.BillImagePath)}
          >
            View
          </button>
        ) : (
          <>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              style={{ display: "none" }}
              id={`capture-${row.ID}`}
              onChange={(e) => handleImageUpload(e, row.ID)}
            />
            <label htmlFor={`capture-${row.ID}`} className="btn btn-sm btn-outline-secondary">
              Capture
            </label>
          </>
        )
    },
    {
      name: "Created At",width:"150px",
      selector: (row) => new Date(row.CreatedAt).toLocaleString("en-GB"),
      sortable: true
    },
    { name: "Received At", width:"150px",selector: (row) => row.ReceivedAt || "N/A", sortable: true },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-sm btn-danger"
          onClick={() => handleDelete(row.ID)}
        >
          Delete
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }
    
  ];

  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${type === "success" ? "Success!" : "Error!"}</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 2000);
  };

  const getUOMByProduct = (product) =>
  axiosInstance.get('/api/uom-by-product', { params: { product } });
  
  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "-webkit-fill-available" }}>
          <div id="alertPlaceholder"></div>
          <div className="d-flex justify-content-end mb-3">
            <button className="btn btn-primary" onClick={() => setShowModal(true)}>
              Add New
            </button>
          </div>
          <DataTable columns={columns} data={records} pagination />
        </main>
      </div>

      {showImageModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal show" style={{ display: "block" }}>
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Purchase Bill</h5>
                  <button className="btn-close" onClick={() => setShowImageModal(false)}></button>
                </div>
                <div className="modal-body text-center">
                  <img src={selectedImage} alt="Bill" style={{ maxWidth: "100%", maxHeight: "500px" }} />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Add New Record Modal */}
      {showModal && (
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Purchase Bill</h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleFormSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Bill Number</label>
                    <input
                      type="text"
                      name="BillNumber"
                      value={formData.BillNumber}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                      placeholder="Enter Bill Number"
                    />
                  </div>
                  {/* <div className="mb-3">
                  <label className="form-label">Product</label>
                  <select
                    name="Product"
                    value={formData.Product || ""}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  >
                    <option value="" disabled>
                      -- Select Product --
                    </option>
                    {PRODUCT_OPTIONS.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div> */}
                <div className="mb-3">
                  <label className="form-label">Product</label>
                  <select
                    name="Product"
                    value={formData.Product || ""}
                    onChange={async (e) => {
                      const value = e.target.value;

                      // Update Product immediately
                      setFormData(prev => ({ ...prev, Product: value, UOM: "" }));

                      try {
                        const { data } = await getUOMByProduct(value);
                        setFormData(prev => ({ ...prev, Product: value, UOM: data?.uom || "" }));
                      } catch (err) {
                        console.warn('UOM not found for product:', value);
                        setFormData(prev => ({ ...prev, UOM: "" }));
                      }
                    }}
                    className="form-control"
                    required
                  >
                    <option value="" disabled>-- Select Product --</option>
                    {PRODUCT_OPTIONS.map((opt) => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">UOM</label>
                  <input
                    type="text"
                    name="UOM"
                    onChange={handleInputChange}
                    value={formData.UOM || "N/A"}
                    className="form-control"
                    readOnly
                  />

                </div>
 
                  <div className="mb-3">
                    <label className="form-label">Quantity</label>
                    <input
                      type="number"
                      name="Quantity"
                      value={formData.Quantity}
                      onChange={handleInputChange}
                      className="form-control"
                      step="0.01"
                      required
                      placeholder="Enter Quantity"
                    />
                  </div>

                   <div className="mb-3">
                    <label className="form-label">Quantity In KG / pcs</label>
                    <input
                      type="number"
                      name="Quantity_in_KG"
                      value={formData.Quantity_in_KG}
                      onChange={handleInputChange}
                      className="form-control"
                      step="0.01"
                      required
                      placeholder="Enter Quantity In KG / pcs"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">PO Number</label>
                    <div className="input-group">
                      <select
                        className="form-select"
                        style={{ maxWidth: 130 }}
                        value={poPrefix}
                        onChange={(e) => setPoPrefix(e.target.value)}
                        required
                      >
                        <option value="">-- Prefix --</option>
                        {PO_PREFIXES.map((p) => (
                          <option key={p} value={p}>{p}</option>
                        ))}
                      </select>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter PO number (e.g., 240)"
                        value={poSuffix}
                        onChange={(e) => setPoSuffix(e.target.value)}
                        maxLength={50}
                      />
                    </div>

                    {/* Read-only preview */}
                    <div className="form-text">
                      Final PO Number: <strong>{formData.PO_Number || "—"}</strong>
                    </div>
                  </div>

                  <div className="mb-3 ">
                    <label className="form-label">Loading / Unloading Amount</label>
                    <input
                      type="text"                  // DB column is varchar(100). If you prefer numeric, change to type="number".
                      name="Loading_Unloading_amount"
                      value={formData.Loading_Unloading_amount}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="e.g. 1500"
                      maxLength={100}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Transporter Name</label>
                    <select
                      name="Transporter_Name"
                      value={formData.Transporter_Name || ""}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    >
                      <option value="" disabled>
                        -- Select Transporter --
                      </option>
                      {TRANSPORTER_OPTIONS.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Remarks</label>
                    <textarea
                      name="Remarks"
                      value={formData.Remarks}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter Remarks"
                      rows="3"
                      
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">Submit</button>
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchaseBillUpload;
